export default __webpack_public_path__ + "static/media/domain.66ad627d.svg";